<template>
  <div>
    <q-form ref="editForm">
      <c-card title="순회점검계획 정보" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline >
            <c-btn
              v-show="disabled && editable"
              :url="cancelUrl"
              :isSubmit="isCancel"
              :param="place"
              mappingType="PUT"
              label="완료취소"
              icon="restart_alt"
              @beforeAction="cancelPlace"
              @btnCallback="cancelCallback" 
            />
            <c-btn
              v-show="!disabled && editable"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="place"
              mappingType="PUT"
              label="저장"
              icon="save"
              @beforeAction="savePlace"
              @btnCallback="saveCallback" 
            />
            <c-btn
              v-show="!disabled && editable"
              :url="completeUrl"
              :isSubmit="isComplete"
              :param="place"
              mappingType="PUT"
              label="완료"
              icon="check"
              @beforeAction="completePlace"
              @btnCallback="completeCallback" 
            />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
            <c-datepicker
              :editable="editable && !disabled"
              label="순회일"
              name="patrolDate"
              v-model="place.patrolDate"
              @datachange="placeChange"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <c-multi-field
              :editable="editable"
              :disabled="true"
              label="점검자"
              type="user"
              name="checkUserId"
              v-model="patrol.checkUserId">
            </c-multi-field>
          </div>
        </template>
      </c-card>
        <!-- :data="place.resultMaps" -->
      <c-table
        ref="table"
        title="순회 일상점검 Check-List"
        :columns="gridColumns"
        :gridHeight="gridHeight"
        :data="filterData"
        :merge="grid.merge"
        :filtering="false"
        :columnSetting="false"
        :usePaging="false"
        :editable="editable && !disabled"
        @table-data-change="tableDataChange"
      >
        <template slot="suffixTitle">
          <font class="text-negative" style="font-size:0.8em;font-weight:300;">
            양호(O) ,  불량(X) , 즉조치(△)
          </font>
        </template>
        <template v-slot:custom-label-after="{ col }">
          <div v-if="col.name==='saiEquipClassName'">
            <!-- 설비분류 -->
            <c-select
              stype="tableHeaderselect"
              :comboItems="equipComboItems"
              type="allEdit"
              itemText="codeName"
              itemValue="code"
              v-model="filter.saiEquipClassName" />
          </div>
          <div v-if="col.name==='saiItemClassName'">
            <!-- 항목분류 -->
            <c-select
              stype="tableHeaderselect"
              :comboItems="itemComboItems"
              type="allEdit"
              itemText="codeName"
              itemValue="code"
              v-model="filter.saiItemClassName" />
          </div>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="props.row['sopImprovementIds'] && props.row['ibmStepNames']">
            <q-chip
              v-for="(item, index) in $comm.ibmTagItems(props.row)"
              :key="index"
              :color="item.color"
              :clickable="true"
              text-color="white"
              style="margin-bottom:4px !important;"
              @click="linkClick(item, props.row)">
              {{item.title}}
              <c-assess-tooltip 
                :ibmTooltip="item.ibmTooltip"
                :ibmClassCd="item.ibmClassCd"
              />
            </q-chip>
          </template>
          <template v-else-if="col.name==='customCol'">
          <component
            :is="imprComponent"
            :col="col"
            :props="props"
            :inputEditable="false"
            :requestContentsCols="requestContentsCols"
            tableKey="saiPatrolResultId"
            ibmTaskTypeCd="ITT0000065"
            @imprChange="imprChange"
          />
        </template>
          <div v-if="editable && Boolean(props.row.saiPatrolResultId) && props.row.editFlag !== 'C' && !disabled">
            <q-btn-group outline class="ColumInnerBtnGroup">
              <q-btn
                icon="add"
                color="red-6"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '1')">
                <q-tooltip>
                  개선요청등록
                </q-tooltip>
              </q-btn>
              <q-btn
                icon="add"
                color="light-blue"
                text-color="white"
                class="ColumInnerBtn"
                align="center"
                @click.prevent="innerBtnClicked(col, props, '2')">
                <q-tooltip>
                  즉시조치등록
                </q-tooltip>
              </q-btn>
            </q-btn-group>
          </div>
        </template>
      </c-table>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'patrol-place-result',
  props: {
    place: {
      type: Object,
      default: () => ({
        saiPatrolPlaceId: '',  // 순회점검 결과 장소 일련번호
        saiPatrolId: '',  // 순회점검 일련번호
        placeId: '',  // 장소번호
        patrolDate: '',  // 순회일
        patrolPlaceStepCd: '',
        regUserId: '',  //
        resultMaps: [],
        results: [],
        lines: [],
      }),
    },
    patrol: {
      type: Object,
      default: () => {
        return {
          patrolStepCd: '',
          checkUserId: '',
        }
      }
    },
    contentHeight: null,
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'saiEquipClassName' },
          { index: 1, colName: 'groupItemClass' },
        ],
      },
      filter: {
        saiEquipClassName: null,
        saiItemClassName: null,
      },
      resultItems: [],
      editable: true,
      detailUrl: '',
      saveUrl: '',
      completeUrl: '',
      cancelUrl: '',
      isSave: false,
      isComplete: false,
      isCancel: false,
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    gridColumns() {
      let defaultCols = [
        {
          name: 'saiEquipClassName',
          field: 'saiEquipClassName',
          label: '설비분류',
          align: 'center',
          sortable: false,
          style: 'width:100px',
        },
        { 
          name: 'saiItemClassName',
          field: 'saiItemClassName',
          label: '항목분류',
          align: 'center',
          sortable: false,
          style: 'width:90px',
        },
        {
          name: 'patrolItemName',
          field: 'patrolItemName',
          label: '점검항목',
          align: 'left',
          sortable: false,
          style: 'width:500px',
        },
      ];
      let lastCol = [
        {
          name: 'patrolContents',
          field: 'patrolContents',
          label: '요청사항',
          align: 'left',
          sortable: false,
          style: 'width:250px',
          type: 'text',
        },
        {
          name: 'impr',
          field: 'impr',
          label: '개선진행',
          align: 'center',
          child: [
            {
              name: 'customCol',
              field: 'customCol',
              label: '개선번호/개선진행상태',
              align: 'center',
              style: 'width:150px',
              type: 'custom',
              sortable: false
            },
          ]
        },
      ];
      if (this.place && this.place.lines && this.place.lines.length > 0 && this.resultItems && this.resultItems.length > 0) {
        let lines = []
        this.$_.forEach(this.place.lines, line => {
          lines.push({
            name: line.lineId,
            field: line.lineId,
            label: line.lineCd,
            align: 'center',
            sortable: false,
            style: 'width:35px',
            type: 'select',
            isChip: true,
            none: true,
            comboItems: this.resultItems,
            required: true,
          })
        })
        defaultCols.push({
          name: 'line',
          field: 'line',
          label: 'Line',
          align: 'center',
          sortable: false,
          child: lines
        })
      }
      defaultCols = this.$_.concat(defaultCols, lastCol)
      return defaultCols;
    },
    gridHeight() {
      return String(this.contentHeight - 240) + 'px';
    },
    disabled() {
      return this.place.patrolPlaceStepCd === 'PPS0000005'
        // || this.patrol.patrolStepCd === 'PS00000010' 
    },
    filterData() {
      return this.place.resultMaps.filter(
        data =>
          (!this.filter.saiEquipClassName || data.saiEquipClassName === this.filter.saiEquipClassName) &&
          (!this.filter.saiItemClassName || data.saiItemClassName === this.filter.saiItemClassName)
      )
    },
    equipComboItems() {
      let data = this.$_.uniq(this.$_.map(this.place.resultMaps, 'saiEquipClassName'))
      if (data && data.length > 0) {
        let comboItems = [];
        this.$_.forEach(data, item => {
          comboItems.push({
            code: item,
            codeName: item
          })
        })
        return comboItems;
      } else {
        return [];
      }
    },
    equipFilterData() {
      if (this.filter.saiEquipClassName) {
        return this.$_.filter(this.place.resultMaps, { saiEquipClassName: this.filter.saiEquipClassName })
      } else {
        return this.place.resultMaps;
      }
    },
    itemComboItems() {
      let data = this.$_.uniq(this.$_.map(this.equipFilterData, 'saiItemClassName'))
      if (data && data.length > 0) {
        let comboItems = [];
        this.$_.forEach(data, item => {
          comboItems.push({
            code: item,
            codeName: item
          })
        })
        return comboItems;
      } else {
        return [];
      }
    },
    imprComponent() {
      let components = () => import(`${'@/pages/common/ibm/tableImpr.vue'}`);
      return components;
    },
    requestContentsCols() {
      return ['saiEquipClassName', 'patrolItemName', 'patrolContents'];
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sai.patrol.place.get.url;
      this.saveUrl = transactionConfig.sai.patrol.place.save.url;
      this.completeUrl = transactionConfig.sai.patrol.place.save.url;
      this.cancelUrl = transactionConfig.sai.patrol.place.cancel.url;
      // code setting
      this.$comm.getComboItems('PATROL_LINE_RESULT_CD').then(_result => {
        this.resultItems = _result
      });
      // list setting
    },
    getDetail() {
      if (this.place.saiPatrolPlaceId) {
        this.$http.url = this.$format(this.detailUrl, this.place.saiPatrolPlaceId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.$_.extend(this.place, _result.data);
        },);
      }
    },
    /* eslint-disable no-unused-vars */
    imprChange(data) {
      this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
    },
    placeChange() {
      this.place.editFlag = 'U'
    },
    tableDataChange(props, col) {
      let colName = col.name
      /**
       * 요청사항은 테이블 컴포넌트에서 처리됨
       * 
       * 아래의 경우는 라인의 결과값을 변경했을 경우임
       */
      if (colName !== 'patrolContents') {
        if (props.row[colName + 'EditFlag'] !== 'C') {
          props.row[colName + 'EditFlag'] = 'U'
        }
        
      }
    },
    innerBtnClicked(col, props, value) {
      this.requestImprRow = props.row
      let requestContents = props.row.saiEquipClassName + ' / '
        + props.row.saiItemClassName + ' / '
        + props.row.patrolItemName;

      if (value === '1') {
        this.popupOptions.title = '개선 요청';
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.saiPatrolResultId,
          ibmTaskTypeCd: 'ITT0000065',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
      } else {
        this.popupOptions.title = '즉시조치'; // 즉시조치 상세
        this.popupOptions.param = {
          requestContents: requestContents,
          relationTableKey: props.row.saiPatrolResultId,
          ibmTaskTypeCd: 'ITT0000065',
        };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
      }
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup;
    },
    closeAddImprPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;

      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          let sData = this.requestImprRow.sopImprovementIds ? this.requestImprRow.sopImprovementIds : '';
          if (sData.indexOf(item.sopImprovementId) === -1) {
            this.requestImprRow.sopImprovementIds = this.requestImprRow.sopImprovementIds ? 
              this.requestImprRow.sopImprovementIds + ',' + item.sopImprovementId : item.sopImprovementId
            this.requestImprRow.ibmStepNames = this.requestImprRow.ibmStepNames ? 
              this.requestImprRow.ibmStepNames + ',' + item.ibmStepName : item.ibmStepName
            this.requestImprRow.ibmClassCds = this.requestImprRow.ibmClassCds ? 
              this.requestImprRow.ibmClassCds + ',' + item.ibmClassCd : item.ibmClassCd
            this.requestImprRow.ibmTooltip = this.requestImprRow.ibmTooltip ? 
              this.requestImprRow.ibmTooltip + ',' + item.ibmTooltip : item.ibmTooltip
          }
        })
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
        this.$emit('research')
      }
    },
    linkClick(data, row) {
      this.requestImprRow = row
      this.imprData = data;
      if (data.ibmClassCd === 'IC00000001') {
        this.popupOptions.title = '개선';
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
      }
      this.popupOptions.param = {
        sopImprovementId: data.sopImprovementId,
      };
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeImprPopup;
    },
    closeImprPopup(result, flag) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (result && result.col1) {
        if (flag !== 'delete') {
          if (result.col1.ibmStepCd === 'IS00000010' || result.col1.ibmStepCd === 'IS00000015' || result.col1.ibmStepCd === 'IS00000020') {
            this.requestImprRow.riskRegisterFlag = true
          }
          let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
          let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
          if (splitId && splitId.length > 0) {
            let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
            splitStep[idIndex] = result.col1.ibmStepName;
            this.requestImprRow.ibmStepNames = splitStep.toString();
          }
        } else {
          let splitId = this.$_.split(this.requestImprRow.sopImprovementIds, ',');
          let splitStep = this.$_.split(this.requestImprRow.ibmStepNames, ',');
          let splitClass = this.$_.split(this.requestImprRow.ibmClassCds, ',');
          if (splitId && splitId.length > 0) {
            let idIndex = this.$_.indexOf(splitId, result.col1.sopImprovementId);
            splitId.splice(idIndex, 1)
            splitStep.splice(idIndex, 1)
            splitClass.splice(idIndex, 1)
            this.$set(this.requestImprRow, 'sopImprovementIds', splitId.toString())
            this.$set(this.requestImprRow, 'ibmStepNames', splitStep.toString())
            this.$set(this.requestImprRow, 'ibmClassCds', splitClass.toString())
          }

        }
        this.$refs['table'].$refs['compo-table'].resetVirtualScroll();
      }
    },
    savePlace() {
      // line 별로 점검이 이루어졌는지?
      // 순회일을 입력했는지?
      this.$refs['editForm'].validate().then(_result => {
        if (_result && this.$comm.validTable(this.gridColumns, this.place.resultMaps)) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.place.chgUserId = this.$store.getters.user.userId
              this.place.editFlag = 'U'
              this.place.results = [];
              this.$_.forEach(this.place.resultMaps, resultMap => {
                let resultLines = [];
                this.$_.forEach(this.place.lines, line => {
                  resultLines.push({
                    saiPatrolResultLineId: resultMap[line.lineId + 'Id'],  // 순회점검 결과별 라인 결과 일련번호
                    saiPatrolResultId: resultMap.saiPatrolResultId,  // 순회점검 결과 일련번호
                    lineId: line.lineId,  // 라인일련번호
                    lineCd: line.lineCd,  // 라인번호
                    patrolLineResultCd: resultMap[line.lineId],  // 점검결과 코드
                    regUserId: this.$store.getters.user.userId,  //
                    chgUserId: this.$store.getters.user.userId,  //
                    editFlag: resultMap[line.lineId + 'EditFlag']
                  })
                });
                this.place.results.push({
                  saiPatrolResultId: resultMap.saiPatrolResultId,  // 순회점검 결과 일련번호
                  saiPatrolPlaceId: this.place.saiPatrolPlaceId,  // 순회점검 결과 장소 일련번호
                  saiPatrolResultItemId: resultMap.saiPatrolResultItemId,  // 순회점검 일련번호
                  patrolItemName: resultMap.patrolItemName,  // 점검항목
                  patrolContents: resultMap.patrolContents,  // 요청내용
                  regUserId: this.$store.getters.user.userId,  //
                  chgUserId: this.$store.getters.user.userId,  //
                  editFlag: resultMap.editFlag,
                  resultLines: resultLines,
                })
              })
              this.isSave = !this.isSave
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getDetail();
    },
    completePlace() {
      // line 별로 점검이 이루어졌는지?
      // 순회일을 입력했는지?
      this.$refs['editForm'].validate().then(_result => {
        if (_result && this.$comm.validTable(this.grid.columns, this.place.resultMaps)) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '완료하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.place.editFlag = 'U'
              this.place.chgUserId = this.$store.getters.user.userId
              this.place.patrolPlaceStepCd = 'PPS0000005'
              this.place.results = [];
              this.$_.forEach(this.place.resultMaps, resultMap => {
                let resultLines = [];
                this.$_.forEach(this.place.lines, line => {
                  resultLines.push({
                    saiPatrolResultLineId: resultMap[line.lineId + 'Id'],  // 순회점검 결과별 라인 결과 일련번호
                    saiPatrolResultId: resultMap.saiPatrolResultId,  // 순회점검 결과 일련번호
                    lineId: line.lineId,  // 라인일련번호
                    lineCd: line.lineCd,  // 라인번호
                    patrolLineResultCd: resultMap[line.lineId],  // 점검결과 코드
                    regUserId: this.$store.getters.user.userId,  //
                    chgUserId: this.$store.getters.user.userId,  //
                    editFlag: resultMap[line.lineId + 'EditFlag']
                  })
                });
                this.place.results.push({
                  saiPatrolResultId: resultMap.saiPatrolResultId,  // 순회점검 결과 일련번호
                  saiPatrolPlaceId: this.place.saiPatrolPlaceId,  // 순회점검 결과 장소 일련번호
                  saiPatrolResultItemId: resultMap.saiPatrolResultItemId,  // 순회점검 일련번호
                  patrolItemName: resultMap.patrolItemName,  // 점검항목
                  patrolContents: resultMap.patrolContents,  // 요청내용
                  regUserId: this.$store.getters.user.userId,  //
                  chgUserId: this.$store.getters.user.userId,  //
                  editFlag: resultMap.editFlag,
                  resultLines: resultLines,
                })
              })

              this.isComplete = !this.isComplete
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          this.place.patrolPlaceStepCd === 'PPS0000001'
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      if (_result.data === 'PS00000010') {
        this.$emit('tranStep')
      } else {
        this.getDetail();
      }
    },
    cancelPlace() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '완료취소 하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.place.chgUserId = this.$store.getters.user.userId

          this.isCancel = !this.isCancel
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    cancelCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.patrol.patrolStepCd = 'PS00000005'
      this.place.patrolPlaceStepCd = 'PPS0000001'
      // if (_result.data === 1) {
      //   this.getDetail();
      // } else {
      //   this.$emit('tranStep')
      // }
    },
  }
};
</script>
